const host = typeof window !== "undefined" ? window.location.host : "";

export const SDK_DOMAIN = /\.com/.test(host) ? "com" : "tech";
export const IS_PRODUCTION_DOMAIN = SDK_DOMAIN === "com";
const project = IS_PRODUCTION_DOMAIN ? "welfare_platform" : "welfare_platform_test";

export const DEFAULT_SDK_URL = `https://cdn.guanaitong.${SDK_DOMAIN}/s2/g/sensorsdata/sensorsdata.min.js`;
export const DEFAULT_SERVER_URL = `https://guanaitong-pro.datasink.sensorsdata.cn/sa?project=${project}`;
export const DEFAULT_PLATFORM_NAME = "给到";
export const DEFAULT_PLATFORM_TYPE = "H5";
export const SDK_SCRIPT_ID = "GAT_SENSORS_DATA_SDK";
export const DEFAULT_APP_JS_BRIDGE = true;
export const DEFAULT_EXPOSURE_PLUGIN_URL = `https://cdn.guanaitong.${SDK_DOMAIN}/s2/g/sensorsdata/exposure/index.es6.js`;
export const DEFAULT_EXPOSURE_AREA_RATE = 0.5;
export const DEFAULT_EXPOSURE_STAY_DURATION = 1;
export const DEFAULT_EXPOSURE_REPEATED = true;
